import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "numberToWords",
})
export class NumberToWordsPipe implements PipeTransform {
	private words: string[] = [
		"zero",
		"one",
		"two",
		"three",
		"four",
		"five",
		"six",
		"seven",
		"eight",
		"nine",
		"ten",
		"eleven",
		"twelve",
		"thirteen",
		"fourteen",
		"fifteen",
		"sixteen",
		"seventeen",
		"eighteen",
		"nineteen",
		"twenty",
	];

	transform(value: number): string {
		if (value >= 0 && value <= 20) {
			return this.words[value];
		}
		return value.toString(); // fallback
	}
}
